import { Link } from 'react-router';
import { buildMeta, breadcrumbSchema } from '~/lib/seo';
import { SITE } from '~/data/site';
import { shippedIndustries } from '~/data/industries';

export function meta() {
  return buildMeta({
    title: 'Who we clean for',
    description:
      'Offices, medical and dental practices, property managers and churches across Tampa Bay — and the question each one needs answered before signing.',
    path: '/industries',
    jsonLd: breadcrumbSchema([
      { name: 'Home', url: '/' },
      { name: 'Industries', url: '/industries' },
    ]),
  });
}

export default function Industries() {
  return (
    <>
      <section className="hero dusk grain">
        <div className="shell">
          <div className="hero-inner">
            <p className="eyebrow-pill">Industries</p>
            <h1>Same crew. Different questions.</h1>
            <p className="lede">
              A dental practice worries about bloodborne pathogens. A church worries about who is
              in the building around the children. Pick the one that sounds like your building.
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="grid-2">
            {shippedIndustries().map((i) => (
              <Link key={i.slug} to={`/industries/${i.slug}`} className="card card-link">
                <h3 style={{ fontSize: 'var(--step-1)' }}>{i.name}</h3>
                <p className="small" style={{ fontStyle: 'italic' }}>
                  &ldquo;{i.fear}&rdquo;
                </p>
                <p>{i.blurb}</p>
                <span className="card-more">What you need to know →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="dawn">
        <div className="shell">
          <div className="cta-inner">
            <h2>Building not on the list?</h2>
            <p>It probably still fits. Send us a note and describe it.</p>
            <div className="btn-row">
              <Link to="/quote" className="btn btn-secondary">
                Get a quote
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
